export default __webpack_public_path__ + "static/media/ic-chauffage.de762bb7.svg";